<template>
<div id="services">
    <vue-headful title="Users" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon v-if="$vuetify.breakpoint.smAndDown" class="px-1" medium @click="dialog_mobile_sort = true">swap_vert
                </v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" class="mx-1" smal rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize caption">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat>
            <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="pb-5">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-service-item :item="item" @click.native="seeItem2(item)" :key="item.id" />
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>

    </v-container>

    <!-- add button -->
    <v-btn color="primary elevation-16" fab large fixed bottom right @click="dialog1=true">
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->

    <im-service-modal-crud :dialog="dialog1" :item_id="service_id" @exit="dialog1=false,service_id=null" />

    <im-service-modal-view :dialog="dialog2" :item_id="service_id" @exit="dialog2=false,service_id=null" @refresh="getItems()" @edit="editItem($event)" />

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">Sort Items by</v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_mobile_sort = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../components/utils/PropDefaults.js"
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMSortField from "../../components/utils/IMSortField.vue";
import IMServiceItem from '../../components/items/Services/Card.vue';
import IMServiceModalCrud from '../../components/items/Services/AddModal.vue';
import IMServiceModalView from '../../components/items/Services/ViewModal.vue';

export default {
    components: {
        'im-table-header': IMTableHeader,
        'im-sort-filed': IMSortField,
        'im-service-item': IMServiceItem,
        'im-service-modal-crud': IMServiceModalCrud,
        'im-service-modal-view': IMServiceModalView
    },

    data() {
        return {
            // modal
            dialog_service: false,
            edit_dialog: false,
            delete_dialog: false,
            dialog_mobile_sort: false,
            loading_delete: false,
            loading_save: false,

            dialog1: false,
            dialog2: false,
            service_id: null,

            // search
            search: null,
            search_fields: [
                {
                    text: 'Color',
                    value: 'color',
                    selected: true
                }, {
                    text: 'Slug',
                    value: 'slug',
                    selected: true
                }, {
                    text: 'Name',
                    value: 'name',
                    selected: true
                }, {
                    text: 'Description',
                    value: 'description',
                    selected: false
                }
            ],
            search_timeout: 500,

            // table attributes
            loading: null,
            current_stamp: null,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

            im_header: [{
                    text: "Color",
                    width: "8.3%",
                    sortable: false,
                }, {
                    text: "Slug",
                    width: "25%",
                    sortable: true,
                    sort_order: 'slug',
                    sort_dir: null,
                }, {
                    text: "Name",
                    width: "25%",
                    sortable: true,
                    sort_order: 'name',
                    sort_dir: null,
                }, {
                    text: "Description",
                    width: "41.7%",
                    sortable: false,
                    sort_order: 'description',
                    sort_dir: null,
                },
            ],

            // props
            service: defaults.service_item,
            items: [],

            //validation
            valid: false,
            rules: {
                color: [
                        v => !!v || 'Color is required.',
                        v => /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(v) || 'Not a valid hex code.'
                      ],
                slug: [
                        v => !!v || 'Slug is required',
                        v => /^[A-Za-z0-9]+(?:_[A-Za-z0-9]+)*$/.test(v) || 'Not a valid slug, must only contain letters, numbers & underscores.'
                      ],
                name: [v => !!v || 'Name is required'],
                description: [v => !!v || 'Description is required']
            },

        }
    },

    watch: {
        page: {
            handler() {
                this.getItems()
            }
        },
        size: {
            handler() {
                this.getItems()
            }
        },
        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 200)
            }
        },

    },

    created() {
        this.getItems()
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === '' || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/services';

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    // if the current stamp matches the received stamp, populate items
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        openCreateModal() {
            this.service = this.$clone(defaults.service_item);
            // this.$refs.form.reset();
            this.edit_dialog = true;
        },

        openEditModal() {
            // this.$refs.form.validate();
            this.edit_dialog = true;
        },

        openDeleteModal() {
            this.delete_service = this.$clone(this.service);
            this.delete_dialog = true;
        },

        goTo(service_id) {
            this.$router.push({
                path: '/services/' + service_id
            });
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.page = 1;
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.page = 1;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        seeItem(current_service) {
            this.service = this.$clone(current_service);
            this.dialog_service = true;
        },
        seeItem2(current_service) {
            this.service_id = current_service.id;
            this.dialog2 = true;
        },

        editItem(current_service) {
            this.service_id = current_service;
            this.dialog1 = true;
        }

    }
}
</script>
